import { smetaModals } from "../../MainPage/Tools/modalManager";
import React from "react";
import { getModalSectionID, getStyleWindow } from "../../MainPage/Tools/Tools";
import { resumeRequest } from "../TokenProcessing";
import HandleTable from "./HandleTable";

interface Data {
  json: {
    Params: {
      ObjType?: string;
      Module?: string;
      ObjRef?: string;
      RequestID?: string;
      OnlyView?: string;
      MultiSel?: string;
      Level?: string;
      Code?: string;
      RecordIndex?: string;
      Title?: string;
    };
    CLSID?: string;
    Title?: string;
    Module?: string;
  };
  subData: {
    props: any;
    func: (data: any) => any;
    from: string;
  };
  requestID: string;
}

export const exposeDocument = (data: Data) => {
  const { json, subData, requestID } = data;
  if (json.Params) {
    smetaModals.open(
      <HandleTable
        json={{
          ...json.Params,
          CLSID: "{48C155C0-1336-11D6-9CF2-DB1D5BC3046D}",
        }}
        subData={{
          props: {
            ...json.Params,
            Module: json.Module,
            Buttons: 2,
            SectionID: getModalSectionID(),
            PlaneView: "1",
            detailsOpen: true,
            func: subData.func,
            from: subData.from,
            // htmlInput: json.jsonData.content,
            // caption: json.Params.Caption,
            // RequestID: json.Params.RequestID,
          },
        }}
      />,
      {
        Title: "Документ",
        style: getStyleWindow("{48C155C0-1336-11D6-9CF2-DB1D5BC3046D}"),
        onClose: () => {
          subData.props?.input?.current?.focus();
          resumeRequest(requestID, subData, {});
        },
        callBacks: true,
      },
    );
  }
};
